import { setWebsiteSettings } from '../website-settings/website-settings-actions'
import { WebsitePageInterface } from './website-pages-types'
import { AppDispatch } from 'client/store'

export const fetchWebsitePageDataSuccess =
  (data: WebsitePageInterface) => async (dispatch: AppDispatch) => {
    dispatch(setWebsiteSettings(data.website))
  }
